import React, { memo, useEffect, useRef, useState } from 'react'
import { Button, Grid, useMediaQuery } from '@material-ui/core'
import { UserPlusIcon } from 'asterX-UI/Icons'
import { PageContainer } from 'components/PageContainer'

import Filter from './components/Filter/Filter'
import RolesModal from './components/Roles/RolesModal'

import { useTranslation } from 'react-i18next'
import { useHomeStore } from 'context/HomeStore'
import { LoaderBackdrop } from 'asterX-UI/Loaders'
import GroupAddOutlinedIcon from '@material-ui/icons/GroupAddOutlined';
import { ListUsers } from 'pages/Home/components/ListUsers'
import { Pagination } from 'asterX-UI/Pagination'
import { useAuthStore } from 'context/AuthStore'
import { useRoutes } from 'hooks'
import { CREATE_USER_PATH } from 'routes/constants.routes';


const Home = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('md'))
  const { t } = useTranslation()
  const _isMounted = useRef(true)
  const { homeStore, homeStoreFunc } = useHomeStore()
  const { authStore } = useAuthStore()
  const { goTo } = useRoutes()
  const pagination = homeStore.pagination
  const [isRolesOpen, setIsRolesOpen] = useState(false)


  useEffect(() => {
    homeStoreFunc.changeRowsPerPageByView(homeStore.isMobileView)
    return () => {
      _isMounted.current = false
    }
  }, [homeStore.isMobileView])

  const onPaginationChange = (e, page) => {
    page = page === 0 ? page : page - 1
    homeStoreFunc.onPaginationChange(page)
  }

  const onNewUser = () => {
    goTo(CREATE_USER_PATH)
  }
  return (
    <PageContainer
      headerProps={{
        rightComponent: (
          <Grid item container justifyContent='flex-end' spacing={3} >
            <Grid item >
              <Button
                variant={'contained'}
                size={'small'}
                onClick={() => setIsRolesOpen(true)}
              >
                <GroupAddOutlinedIcon />
                {t('profilePage.giveRoles')}
              </Button>
            </Grid>
            <Grid item >
              <Button variant={'contained'} color={'primary'}   size={'small'} onClick={onNewUser}>
                <UserPlusIcon fontSize={'small'} /> {t('homePage.createUser')}
              </Button>
            </Grid>
          </Grid>
        )
      }}
    >
      <LoaderBackdrop loading={!!homeStore.loading} />
      <Grid container>
        <Grid item xs={12} md={12}>
          <Filter />
        </Grid>
        <Grid item xs={12} md={12}>
          <ListUsers />
        </Grid>
        <Grid
          item
          xs={12}
          md={12}
          style={{
            marginTop: 24,
            marginBottom: 48
          }}
        >
          <Pagination
            count={pagination?.pageCount}
            page={pagination?.page + 1}
            onChange={onPaginationChange}
            isMobile={isMobile}
          />
        </Grid>
      </Grid>
      <RolesModal isRolesOpen={isRolesOpen} onClose={() => setIsRolesOpen(false)} onCancel={() => setIsRolesOpen(false)} />
    </PageContainer>
  )
}
export default memo(Home)
